import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { List, Body } from "./components";
import { connect } from "react-redux";
import * as actions from "redux/actions/noteActions";
import { Translate } from "react-redux-i18n";

const Notes = (props) => {
    const [values, setValues] = useState({
        text: (props.item && props.item.text) || ""
    });

    useEffect(() => {
        setValues({
            text: (props.item && props.item.text) || ""
        });
    }, [props.item && props.item.id]);

    const persistText = (text) => {
        if (!props.item || !props.item.id) {
            return;
        }

        props.UpdateItem({
            id: props.user_id,
            text,
            note_id: props.item.id
        }, props.token);
    };

    const handleClickSave = () => {
        persistText(values.text);
    };

    const handleImageInserted = (html) => {
        setValues((prev) => ({
            ...prev,
            text: html
        }));
        persistText(html);
    };

    const onChange = (event) => {
        const { name, value } = event.target;
        setValues((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const onClickSelect = (item) => {
        setValues({
            text: item.text || ""
        });
        props.setItem(item);
    };

    const handleClickNew = () => {
        props.newItem({
            title: "New Note",
            id: props.user_id,
        }, props.token);
    };

    const canSave = Boolean(props.item && props.item.id);

    return (
                <div className="knowledge-panel">
                    <div className="card-header">
                            <div className="card-header-title">
                                <Translate value="Notas" />
                            </div>
                            <div className="knowledge-header-actions">
                                    <button
                                    className="btn btn-primary"
                                    type="button"
                                    onClick={handleClickNew}
                                    >
                                        <Translate value="new" />
                                    </button>
                                    <button
                                    className="btn btn-primary"
                                    type="button"
                                    onClick={handleClickSave}
                                    disabled={!canSave}
                                    >
                                        <Translate value="save" />
                                    </button>
                            </div>
                    </div>
                    <div className="card-content">
                        <div className="knowledge-layout">
                                <List onClick={onClickSelect} />
                                <div className="knowledge-main">
                                    <Body
                                        onChange={onChange}
                                        onImageInserted={handleImageInserted}
                                        text={values.text}
                                        noteId={props.item && props.item.id}
                                    />
                                </div>
                        </div>
                    </div>
                </div>
    );
};

Notes.propTypes = {
    className: PropTypes.string,
    history: PropTypes.object
};

function mapStateToProps(reducer) {
    //console.log(reducer);    
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,

        list: reducer.note.list,
        loading: reducer.note.loading,
        error: reducer.note.error,

        item: reducer.note.item,
    };
}
const mapDispatchToProps = dispatch => ({
    UpdateItem: (params, token) =>
        dispatch(actions.updateItem({ params, token })),
    loadList: (params, token) =>
        dispatch(actions.loadList({ params, token })),
    setItem: (item) =>
        dispatch(actions.setItem({ item })),
    newItem: (params, token) =>
        dispatch(actions.newItem({ params, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Notes);

